import React from "react";

export default class SyntaxExample extends React.Component {
  static propTypes = {};

  render() {
    const { service, source, operation = 'cdn', dimentions, options, path } =
      this.props;
    const parsedOptions = [];

    if (options) {
      Object.keys(options).forEach((option) => {
        if (option === "wmk-path") {
          options[option] = encodeURIComponent(options[option]);
        }

        parsedOptions.push(`${option}:${options[option]}`);
      });
    }

    return (
      <div className="syntax-example">
        <span className="service">{service}</span>
        <span className="source">/{source}</span>
        {operation && <span className="operation">/{operation}</span>}
        {dimentions && <span className="dimensions">/{dimentions}</span>}
        {options ? (
          <span className="options">/{parsedOptions.join(",")}</span>
        ) : (
          ""
        )}
        <span className="path">{path}</span>
      </div>
    );
  }
}
